function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function trimLeadingSlash(value: string): string {
  return value.replace(/^\/+/, "");
}

function joinUrl(base: string, path: string): string {
  const normalizedBase = trimTrailingSlash(base);
  const normalizedPath = trimLeadingSlash(path);

  return `${normalizedBase}/${normalizedPath}`;
}

function resolveFrappeBaseUrl(): string {
  const explicitBaseUrl = import.meta.env.VITE_API_URL;

  if (explicitBaseUrl)
    return trimTrailingSlash(explicitBaseUrl);

  if (typeof window !== "undefined")
    return trimTrailingSlash(window.location.origin);

  return "";
}

export const FRAPPE_BASE_URL = resolveFrappeBaseUrl();

export function buildFrappeUrl(path: string): string {
  if (/^(https?:\/\/|data:|blob:)/i.test(path))
    return path;

  return joinUrl(FRAPPE_BASE_URL, path);
}
